import React, { Fragment } from "react";
import { useFormikContext } from "formik";
import get from "lodash/get";
import Toggle from "react-toggle";
import { TOGGLE_STATE } from "utils/constants/form";
const DEFAULT_CLASSES = {
  container: "w-100 flex flex-row justify-between items-center",
  label: "f5 fw5 w-100",
  toggle: "flex flex-shrink-0",
  error: "f6 w-100 self-center pt2 tl color-error"
};

const ActiveField = ({ name, value, onChange, customClasses }) => {
  const {
    touched,
    errors,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const error = get(errors, name);
  const showError = Boolean(get(touched, name) && error);
  const toggleProps = {
    icons: false,
    checked: value,
    value: value ? TOGGLE_STATE.YES : TOGGLE_STATE.NO
  };
  if (onChange) {
    toggleProps.onChange = onChange;
  } else {
    toggleProps.onChange = (evt) => {
      const { value } = evt.currentTarget;
      setFieldValue(name, value !== TOGGLE_STATE.YES);
      setFieldTouched(name);
    };
  }

  return (
    <Fragment>
      <div className={classes.container}>
        <div className={classes.label}>{`Active`}</div>
        <div className={classes.toggle}>
          <Toggle {...toggleProps} />
        </div>
      </div>
      {showError && (
        <div className={classes.error}>{`Price can't be empty`}</div>
      )}
    </Fragment>
  );
};

export default ActiveField;
